import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ExploReportBuilderContainer } from 'packages/explo/ui/ExploReportBuilderContainer';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

type PortfolioReportBuilderContainerProps = {
  organizationId: string;
  creditFacilityId: string;
};
export const PortfolioReportBuilderContainer = ({
  organizationId,
  creditFacilityId,
}: PortfolioReportBuilderContainerProps) => {
  const flags = useFeatureFlags();
  const navigate = useNavigate();

  if (!flags) {
    return (
      <Skeleton
        height="600px"
        data-testid="portfolio-report-builder-container-missing-flag"
      />
    );
  }

  // Technically this should never hit as the route has already hidden this,
  // but just keeping as extra safety
  if (!flags.showExploReportBuilder) {
    navigate('/portfolio/overview/facilities');
    return <Skeleton height="600px" />;
  }

  return (
    <ExploReportBuilderContainer
      organizationId={organizationId}
      creditFacilityId={creditFacilityId}
      exploPlacement="lenderFacilitiesTab"
    />
  );
};
